import ApiGateway from '../gateways/Api.gateway';
import { StreamChatCallbacks } from '../utils/streamRequest';

export const chatService = {
  sendMessageStream(message: string, chatSessionId: string | undefined, callbacks: StreamChatCallbacks): Promise<void> {
    return ApiGateway.sendChatMessageStream(message, chatSessionId, callbacks);
  }
};
